export default "__VITE_ASSET__QAgoWkQB__"